module.exports = __webpack_public_path__ + "static/img/classroom_three.ffa7b8cf.jpg";